<template>
  <v-layout fill-height column class="library-sound">
    <v-container flex-fill class="library-sound-content" style="z-index: 1">
      <h3 class="tit">
        {{ resultData.title }}
      </h3>
      <div class="sub-tit">
        {{ resultData.subtitle }}
      </div>
      <div class="cont" v-html="content"></div>
    </v-container>
    <div class="library-sound-controller" style="z-index: 1">
      <VuetifyAudio :file="$downUrl(resultData.musicAtchFileName)"/>
    </div>
    <LoadImage cover
               :src="$downUrl(resultData.bgImgAtchFileName)"
               style="position: fixed; top: 0; left: 0; bottom: 0; right: 0; z-index: 0"
    />
  </v-layout>
</template>

<script>
import VuetifyAudio from './VuetifyAudioNew'

export default {
  components: {
    VuetifyAudio,
  },
  props: {
    resultData: {
      type: Object,
      default: () => ({
        title: null,
        subtitle: null,
        musicAtchFileName: null,
        bgImgAtchFileName: null,
        contentList: []
      })
    }
  },
  computed: {
    content () {
      return this.resultData.contentList[0].content
    }
  }
}
</script>
